






















import {Hints} from '@/interfaces/global-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {Component, Mixins} from 'vue-property-decorator';

@Component({})
export default class HintsContainer extends Mixins(LocalData, Toast, Http) {
    currentTabHints: Hints[] = new Array<Hints>(0)
    showHint: boolean = false
    randomId: string = 'showHint_' + Math.random()

    mounted() {
        this.setHints()
        document.addEventListener('click', this.handleClickOutside)
    }

    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
    }

    onClick(){
        this.showHint = !this.showHint
    }

    handleClickOutside(event: Event) {
        const target = event.target as Element
        const icon = document.getElementById(this.randomId)
        
        // Find the popover by looking for the one that's currently visible
        const popovers = document.querySelectorAll('.b-popover.popover[x-placement]')
        let currentPopover = null
        
        // Find the visible popover (the one that's currently shown)
        for (const popover of popovers) {
            const style = window.getComputedStyle(popover as Element)
            if (style.display !== 'none' && style.visibility !== 'hidden') {
                currentPopover = popover
                break
            }
        }
        
        if (this.showHint && icon) {
            // Check if click is outside both the icon and popover
            const isClickInIcon = icon.contains(target)
            const isClickInPopover = currentPopover ? currentPopover.contains(target) : false
            
            if (!isClickInIcon && !isClickInPopover) {
                this.showHint = false
            }
        }
    }

    setHints() {
        if (!this.$calc.hintsLoaded) {
            setTimeout(this.setHints, 500)
        } else {
            this.currentTabHints = []
            const parentId = this.$parent.$el.id
            this.$log.log(parentId)
            document.querySelectorAll(`#${parentId} [id^=\'hint\']`)
                    .forEach((elem) => {
                        const elemId = Number(elem.id.replace(/\D/g, ''))
                        const hint = this.$calc.currentModuleHints.find((e) => e.hintId === elemId)
                        if (null !== hint && undefined !== hint) {
                            if (hint.hintDesc !== '') {
                                this.currentTabHints.push(hint)
                            }
                        }
                    })
        }
    }
}
